// extracted by mini-css-extract-plugin
export default {"title":"SignIn_title__byKpX","form":"SignIn_form__iIOXb","labels":"SignIn_labels__RzxSi","inputs":"SignIn_inputs__zlTvL","signInButton":"SignIn_signInButton__Uro6C"};